// src/components/Explore.js

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion'; // <-- Framer Motion Import
import CategoryCard from './CategoryCard';
import SearchBar from './SearchBar';
import { ALL_CATEGORIES } from './data/mockRoadmaps.js';
import './Explore.css';

// =======================================
// FRAMER MOTION VARIANTS (Parent Grid)
// =======================================
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.1,   
      staggerChildren: 0.05, 
    }
  }
};


const Explore = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCategories, setFilteredCategories] = useState(ALL_CATEGORIES);

  // Filter categories whenever searchTerm changes (live search)
  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) {
      setFilteredCategories(ALL_CATEGORIES);
      return;
    }

    const results = ALL_CATEGORIES.filter(category =>
      category.title.toLowerCase().includes(term) ||
      category.description.toLowerCase().includes(term)
    );

    setFilteredCategories(results);
  }, [searchTerm]);

  // Update search term from input
  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  // Handle form submit safely (called from SearchBar)
  const handleSubmitSearch = () => {
    console.log(`Search submitted for: "${searchTerm}"`);
  };

  return (
    <div className="explore-page section-padding">
      <div className="explore-header main-content">
        <h1 className="section-heading">Browse All Aspirations</h1>
        <p className="explore-subtext">
          Find your exact career path among our growing library of categories.
        </p>
      </div>

      <div className="explore-search-section main-content">
        <SearchBar
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchSubmit={handleSubmitSearch}
        />
      </div>

      <motion.div
        className="explore-categories-grid main-content"
        key={searchTerm} // CRITICAL: Re-run animation when search term changes
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {filteredCategories.length > 0 ? (
          filteredCategories.map(category => (
            <CategoryCard
              key={category.slug}
              title={category.title}
              description={category.description}
              icon={category.icon}
              slug={category.slug}
            />
          ))
        ) : (
          <div className="no-results">
            No categories found matching "{searchTerm}".
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default Explore;



